import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TTransformedTenant } from '@/backoffice/features/tenants/hooks/use-tenants-transformer/use-tenants-transformer.types';
import { BackofficeTenantFragment } from '@/backoffice/types/types.generated';

export const useTenantsTransformer = () => {
  const { t } = useTranslation();

  const transformTenant = useCallback(
    (tenant: BackofficeTenantFragment): TTransformedTenant => {
      const industry = tenant?.industry
        ? t(`industries:${tenant.industry}`)
        : '-';
      const country = tenant?.country ? t(`countries:${tenant.country}`) : '-';

      return {
        tenantId: tenant.tenantId,
        companyName: tenant.companyName,
        creationDate: tenant.creationTimestamp,
        owner: tenant.owner,
        country,
        industry,
        isActive: tenant.isActive,
        groupId: tenant.groupId,
        tcAccepted: Boolean(tenant.owner?.termsAndConditions?.accepted),
        raw: tenant,
      };
    },
    [t],
  );

  return { transformTenant };
};
